module.exports = __webpack_public_path__ + "static/highley-varlet-logo-a9177e3744f43c03ec41121740ab0d4c.png";